export default {
  root: {
    fontSize: '24px',
  },
  fontSizeLarge: {
    fontSize: '35px',
  },
  fontSizeSmall: {
    fontSize: '20px',
  },
};
